"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTable = void 0;
const __1 = require("..");
const i18n_1 = require("../i18n");
const parseTable = (columns, selectedRows) => {
    const isStringANumber = (s) => {
        const numPattern = /^-?\d+(\.\d+)?$/;
        return numPattern.test(s);
    };
    const filteredColumns = columns.filter((col) => ((0, __1.isValue)(col.tlKey) && col.tlKey !== '') || (0, __1.isValue)(col.label));
    // CSV keys are positional - two columns sharing a col.key would otherwise silently overwrite each other's values
    const config = filteredColumns.map((col, colIdx) => ({
        label: (0, __1.isValue)(col.tlKey) && col.tlKey !== ''
            ? typeof col.tlKey === 'string'
                ? (0, i18n_1.t)(col.tlKey)
                : __1.miscUtil.getNodeText(col.tlKey)
            : __1.miscUtil.getNodeText(col.label),
        key: 'col_' + colIdx,
    }));
    const reducedRows = selectedRows.map((r) => {
        const ret = {};
        filteredColumns.forEach((col, colIdx) => {
            const csvKey = 'col_' + colIdx;
            ret[csvKey] =
                col.rowToFilterType?.(r.original).length &&
                    col.rowToFilterType(r.original)[0].label
                    ? col
                        .rowToFilterType(r.original)
                        .map((item) => item.label)
                        .join(' ')
                    : col.rowToStr
                        ? col.rowToStr(r.original)
                        : r.original[col.key];
            const currentLanguageUsesCommaSeparator = new Intl.NumberFormat((0, i18n_1.getLanguage)())
                .format(0.1)
                ?.includes(',');
            const s = ret[csvKey]?.toString()?.replace(',', '.')?.replace(/\s/g, '');
            const number = parseFloat(s);
            const string = ret[csvKey] ? ret[csvKey].toString().trim() : '';
            ret[csvKey] = !isStringANumber(s)
                ? string
                : currentLanguageUsesCommaSeparator
                    ? number?.toString()?.replace('.', ',')
                    : number;
        });
        return ret;
    });
    return [config, reducedRows];
};
exports.parseTable = parseTable;
